import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Pipe({
  name: 'secure',
})
export class SecurePipe implements PipeTransform {
  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  transform(url, args: any[]): Observable<SafeUrl> {
    return this.http
      .get(url, { responseType: 'blob' })
      .pipe(
        map((val) =>
          this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val))
        ), catchError(
          (error) => this.getFallbackImage(args.length > 0 ? args.toString() : '')
        )
      );
  }

  private getFallbackImage(fallbackUrl: string) {
    if (fallbackUrl) {
      return this.http
        .get(fallbackUrl, { responseType: 'blob' })
        .pipe(
          map((val) =>
            this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val))
          )
        );
    } else {
      return of(null);
    }
  }
}
